import { SET_LABELS } from "../actions/types";

const initialState = {
  languages: ["", "", "", ""],
  setLangBtnTitle: ["", "", "", ""],
  orgTitle: ["", "", "", ""],
  orgTitle1: ["", "", "", ""],
  orgTitle2: ["", "", "", ""],
  searchPlaceholder: ["", "", "", ""],
  rinymLabel: ["", "", "", ""],
  taskLabel: ["", "", "", ""],
  relatedOrgLabel: ["", "", "", ""],
  tmLabel: ["", "", "", ""],
  tmNameLabel: ["", "", "", ""],
  designLabel: ["", "", "", ""],
  designNameLabel: ["", "", "", ""],
  originLabel: ["", "", "", ""],
  originNameLabel: ["", "", "", ""],
  originLabel: ["", "", "", ""],
  exhibitionLabel: ["", "", "", ""],
  categoryLabel: ["", "", "", ""],
  serviceCategoryLabel: ["", "", "", ""],
  rOrgLabel: ["", "", "", ""],
  rNumberLabel: ["", "", "", ""],
  rDateLabel: ["", "", "", ""],
  productLabel: ["", "", "", ""],
  rImageLabel: ["", "", "", ""],
  rVideoLabel: ["", "", "", ""],
  introLabel: ["", "", "", ""],
  linkLabel: ["", "", "", ""],
  addressLabel: ["", "", "", ""],
  faxLabel: ["", "", "", ""],
  emailLabel: ["", "", "", ""],
  telLabel: ["", "", "", ""],
  ownerAddressLabel: ["", "", "", ""],
  descLabel: ["", "", "", ""],
  newLabel: ["", "", "", ""],
  resultLabel: ["", "", "", ""],
  relationLabel: ["", "", "", ""],
  markDescLabel: ["", "", "", ""],
  markDescLabel: ["", "", "", ""],
  markDescLabel: ["", "", "", ""],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LABELS:
      return action.payload;
    default:
      return state;
  }
}
